import { render, staticRenderFns } from "./ClassRoom.vue?vue&type=template&id=b1723402&scoped=true&"
import script from "./ClassRoom.vue?vue&type=script&lang=js&"
export * from "./ClassRoom.vue?vue&type=script&lang=js&"
import style0 from "./ClassRoom.vue?vue&type=style&index=0&id=b1723402&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1723402",
  null
  
)

export default component.exports